import { Container } from 'unstated'

export default class UserResponseStore extends Container {
  state = {
    questionBank: {},
  }

  // for now, whichever box the use selects is the box the question is put in
  // maybe it should always stay this way for simplicity and transparency
  setQuestionResponse = ({ questionBankId, questionId, boxId }) => {
    this.setState(state => {
      const { questionBank } = state
      const thisQuestionBank = questionBank[questionBankId] || {}
      const thisQuestionBankResponses = thisQuestionBank.responses || {}
      const newState = {
        ...state,
        questionBank: {
          ...questionBank,
          [questionBankId]: {
            ...thisQuestionBank,
            responses: {
              ...thisQuestionBankResponses,
              [questionId]: boxId,
            },
          },
        },
      }
      return newState
    })
  }

  workoutCompleted = ({ questionBankId }) => {
    this.setState(state => {
      const { questionBank } = state
      const thisQuestionBank = questionBank[questionBankId] || {}
      const thisQuestionBankProgressCounter = thisQuestionBank.progressCounter || 0
      const newState = {
        ...state,
        questionBank: {
          ...questionBank,
          [questionBankId]: {
            ...thisQuestionBank,
            progressCounter: thisQuestionBankProgressCounter + 1,
          },
        },
      }
      return newState
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/UserResponseStore.js